// The class strings and tone names the toast path needs, in a module with NO imports.
// The shell mounts ToastRegion and ConfirmHost by file, and their static import graph
// must not reach classes.js (which pulls in the 13-hue tables, built with top-level
// calls that Rollup cannot drop: the main chunk grew 693.4 kB -> 707.2 kB). classes.js
// re-exports TONES and toastClasses from here, so there is one source of truth; a test
// asserts the dismiss string equals what iconButtonClasses produces.

export const TONES = Object.freeze(['neutral', 'info', 'success', 'warning', 'danger']);

// A toast is a surface card, so title and message keep ink contrast in both themes. Its
// tone is a 4px bar on the leading edge. pointer-events-auto because the region itself
// is pointer-events-none (it must not block the page under its empty area).
const TOAST_ACCENT = {
  neutral: 'border-l-line-strong',
  info: 'border-l-blue-600 dark:border-l-blue-400',
  success: 'border-l-emerald-600 dark:border-l-emerald-400',
  warning: 'border-l-amber-500 dark:border-l-amber-400',
  danger: 'border-l-rose-600 dark:border-l-rose-400',
};

export function toastClasses({ tone = 'neutral' } = {}) {
  if (!Object.hasOwn(TOAST_ACCENT, tone)) {
    throw new Error(`@platform/ui: unknown tone '${tone}' (one of ${Object.keys(TOAST_ACCENT).join(', ')})`);
  }
  return `pointer-events-auto flex w-full items-start gap-3 rounded-lg border-l-4 bg-surface p-3 text-sm text-ink shadow-lg ring-1 ring-line ${TOAST_ACCENT[tone]}`;
}

// iconButtonClasses({ variant: 'subtle', size: 'sm', tone: 'inherit' }), spelled out.
export const TOAST_DISMISS_CLASSES = 'inline-flex shrink-0 items-center justify-center rounded-md transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600 dark:focus-visible:outline-brand-400 disabled:cursor-not-allowed disabled:opacity-50 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 size-7 [&_svg]:size-4 text-current hover:bg-current/10';
